<template>
    <v-card>
        <v-card-text>
            Kamu akan mendaftar sebagai <b>{{ name }}</b>, lanjutkan?
        </v-card-text>

        <v-card-actions>
            <v-btn @click="logoutAndLogin" text :loading="$store.get('loader/loading', 'logout')">
                gunakan akun lain
            </v-btn>

            <v-btn
                @click="$emit('join')"
                text
                color="primary"
                :loading="$store.get('loader/loading', 'join')"
            >
                daftar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { get } from 'vuex-pathify'
import JoinMixin from '../mixins/JoinMixin'

export default {
    mixins: [JoinMixin],

    props: {
        period: {
            type: Object,
            required: true
        }
    },

    computed: {
        name: get('auth/name')
    },

    methods: {
        logoutAndLogin() {
            this.$api.delete('auth', { loader: 'logout' })
                .then(() => {
                    this.$emit('logout')
                    this.$store.dispatch('auth/unsetData')
                })
        },
    },
}
</script>
